import { RequestsTypesConstants } from 'src/app/core/constants/requests-side-menu.constants';
import { TablePropertiesConstants } from 'src/app/core/constants/table-properties.constant';
import { ViewDetails } from 'src/app/core/models/view-details.model';

export class reportTableConstants {
    public static REPORT_TABLE: ViewDetails = {
        ...RequestsTypesConstants.INPROGRESS_REQUESTS,
        tableColumn: TablePropertiesConstants.REPORT_TABLE_COLUMNS,
        tableWithSelection: false
    };
    public static REPORT_TABLE_LOGISTIC: ViewDetails = {
        ...RequestsTypesConstants.INPROGRESS_REQUESTS,
        tableColumn: TablePropertiesConstants.REPORT_TABLE_LOGISTIC_COLUMNS,
        tableWithSelection: false
    };
    public static REPORT_TABLE_LOGISTIC_DEVICE_ALL_ITEMS: ViewDetails = {
        ...RequestsTypesConstants.INPROGRESS_REQUESTS,
        tableColumn: TablePropertiesConstants.REPORT_TABLE_LOGISTIC_DEVICE_ALL_ITEMS_COLUMNS,
        tableWithSelection: false
    };
    public static REPORT_TABLE_LOGISTIC_DEVICE_ALL_ITEMS_SHARED: ViewDetails = {
        ...RequestsTypesConstants.INPROGRESS_REQUESTS,
        tableColumn: TablePropertiesConstants.REPORT_TABLE_LOGISTIC_DEVICE_ALL_ITEMS_COLUMNS_SHARED,
        tableWithSelection: false
    };
    public static DEVICE_CHANGED_TABLE: ViewDetails = {
        ...RequestsTypesConstants.INPROGRESS_REQUESTS,
        tableColumn: TablePropertiesConstants.DEVICE_CHANGED_TABLE,
        tableWithSelection: false
    };
}
